import { render, staticRenderFns } from "./PostOperatorio.vue?vue&type=template&id=b8cf86d8"
import script from "./PostOperatorio.vue?vue&type=script&lang=js"
export * from "./PostOperatorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports